module.exports = __webpack_public_path__ + "img/a7d982c.png";